import { useAuth0 } from '@auth0/auth0-react'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { EventRequest } from '@estercare/ester-shared'

import { postEvent } from './event'

export const useEventMutation = (options?: UseMutationOptions<Response, Error, EventRequest>) => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationFn: async (event?: EventRequest) => {
      const accessToken = await getAccessTokenSilently()
      if (!event) throw new Error('Event data is required')
      return await postEvent({ accessToken, event })
    },
    ...options,
  })
}
